import {memo} from "react";
import {
    LotsLegendLineDescriptionStyled,
    LotsLegendLineValueStyled,
    LotsLegendProgressBarSliderStyled,
    LotsLegendProgressBarStyled
} from "./styled/LotsLegendLineStyled.js";

const LotsLegendProgressBar = memo((props) => {
    const {className, color, percent, style} = props;
    return (
            <LotsLegendProgressBarStyled className={className} style={style}>
                <LotsLegendProgressBarSliderStyled color={color} width={percent}/>
            </LotsLegendProgressBarStyled>
    );
});

function LotsLegendLine(props) {
    const {amount, children, percent} = props;

    return <div className="flex-grow-1 flex-shrink-1">
            <LotsLegendProgressBar percent={percent} className="mb-1"/>
            <div className="d-flex justify-content-between">
                <LotsLegendLineDescriptionStyled>
                    {children}
                </LotsLegendLineDescriptionStyled>
                <LotsLegendLineValueStyled>
                    {amount}
                </LotsLegendLineValueStyled>
            </div>
        </div>
}

export default LotsLegendLine;
